// routes/_terms.feedback.tsx
import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_terms.feedback'

const getClientModule = () => import('src/clientRoutes/_terms.feedback')

export const handle = { name: 'feedback' }

/**
 * SSR loader for feedback page.
 * Uses default home meta (same as pixai-server HTML template defaults).
 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.home.title'),
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
